export const TRIAL_LINK = 'trial_link';
export const TRIAL_LINK_PAGE = 'trial_link_page';
